(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-accordion-group"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-accordion-group')) {
    class ProductAccordionGroup extends HTMLElement {
      connectedCallback() {
        this.singleOpen = this.dataset.singleOpen === 'true';
        this.items = Array.from(this.querySelectorAll(':scope > .product-accordion-item'));

        this.items.forEach((item) => {
          const label = item.querySelector('.accordion__label');
          const panel = item.querySelector('.product-accordion-item__panel');

          if (!label || !panel) return;

          label.addEventListener('click', () => {
            const isOpen = label.getAttribute('aria-expanded') === 'true';

            if (isOpen) {
              this.closeItem(label, panel);
              return;
            }

            if (this.singleOpen) {
              this.closeOtherItems(item);
            }

            this.openItem(label, panel);
          });
        });

        // If more than one item shipped open from the server (e.g. more than one "Open by
        // default" checked) and only one is allowed, collapse the extras instantly on load.
        if (this.singleOpen) {
          const openItems = this.items.filter((item) => {
            const label = item.querySelector('.accordion__label');
            return label && label.getAttribute('aria-expanded') === 'true';
          });

          openItems.slice(1).forEach((item) => {
            const label = item.querySelector('.accordion__label');
            const panel = item.querySelector('.product-accordion-item__panel');
            this.closeItem(label, panel, true);
          });
        }
      }

      closeOtherItems(currentItem) {
        this.items.forEach((otherItem) => {
          if (otherItem === currentItem) return;

          const otherLabel = otherItem.querySelector('.accordion__label');
          const otherPanel = otherItem.querySelector('.product-accordion-item__panel');

          if (otherLabel && otherLabel.getAttribute('aria-expanded') === 'true') {
            this.closeItem(otherLabel, otherPanel);
          }
        });
      }

      openItem(label, panel) {
        label.setAttribute('aria-expanded', 'true');
        panel.setAttribute('aria-hidden', 'false');
        panel.classList.add('is-open');
      }

      closeItem(label, panel, skipTransition) {
        if (skipTransition) {
          panel.style.transition = 'none';
        }

        label.setAttribute('aria-expanded', 'false');
        panel.setAttribute('aria-hidden', 'true');
        panel.classList.remove('is-open');

        if (skipTransition) {
          // Force layout so the transition-less state is committed before we hand transitions back.
          void panel.offsetHeight;
          panel.style.transition = '';
        }
      }
    }

    customElements.define('product-accordion-group', ProductAccordionGroup);
  }
  } catch(e) { console.error(e); }
})();

})();
